// Uplift/delta is relative to another value, so it can be negative. toFixed
// already renders the minus; only positives need an explicit plus. Keeps the
// sign in code so copy templates never hardcode a "+" (which would render
// "+-2.0" for a negative value).
export const formatUplift = (value: number): string =>
  `${value >= 0 ? '+' : ''}${value.toFixed(1)}`;
